import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import type * as React from 'react';

const sampleStyle = css`
	margin: 0;
	padding: 0.875rem 1rem;
	border-radius: ${theme.radii.medium};
	background-color: ${theme.colors.surfaceMuted};
	font-family: ${theme.fonts.body};
	font-size: ${theme.fontSizes.medium};
	color: ${theme.colors.inkSecondary};
`;

type Props = {
	readonly sampleText: string | null;
};

/** `null` once a speaker holds no turn at all (§8.2) — renders nothing rather than an empty block. */
const SpeakerAssignmentSampleQuote: React.FC<Props> = ({ sampleText }) => {
	if (sampleText === null) {
		return null;
	}

	return <p css={sampleStyle}>{sampleText}</p>;
};

export default SpeakerAssignmentSampleQuote;
